import { Component, HostListener, Input, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { GlobalErrorService } from './global-error.service';
import { GlobalErrorPayload } from './global-error.types';

// To put ouside the route outlet
@Component({
  selector: 'global-error-popup',
  templateUrl: './error-pop-up.component.html',
  styleUrls: ['./error-pop-up.component.scss'],
  standalone: false,
})
export class ErrorPopUpComponent implements OnInit {
  private readonly globalErrorService = inject(GlobalErrorService);

  errorDisplay = false;

  globalError$: Observable<GlobalErrorPayload>;

  // the default common settings filename is 'common-settings'
  @Input('common-settings')
  set commonSettingsFileName(fileName: string) {
    this.globalErrorService.commonSettingsFileName = fileName;
  }

  constructor() {
    this.globalError$ = this.globalErrorService.globalError$.pipe(
      tap(() => {
        this.errorDisplay = true;
      }),
    );
  }

  ngOnInit() {
  }

  // take action or cancel
  @HostListener('window:popstate') // destroy the pop up if the user quits the current page
  onClick(buttonCallback?: () => void) {
    if (buttonCallback) {
      buttonCallback();
    }
    this.errorDisplay = false;
  }
}
